import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=49acd72f&scoped=true"
import script from "./NumberInput.vue?vue&type=script&lang=js"
export * from "./NumberInput.vue?vue&type=script&lang=js"
import style0 from "./NumberInput.vue?vue&type=style&index=0&id=49acd72f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49acd72f",
  null
  
)

export default component.exports